var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('PageTitle', {
    attrs: {
      "title": _vm.$t('page.title'),
      "icon": "pe-7s-global",
      "subtitle": _vm.$t('page.subtitle')
    },
    scopedSlots: _vm._u([{
      key: "subTitle",
      fn: function () {
        return [_vm.locations.length > 0 ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('page.subtitle')) + " ")]) : _vm._e()];
      },
      proxy: true
    }])
  }), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_vm.hasAllPermissions('locations.edit.batch', 'locations.servicetimes.edit') ? _c('div', {
    staticClass: "form-check",
    staticStyle: {
      "line-height": "200%"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.isBatchEditEnabled,
      expression: "isBatchEditEnabled"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "isBatchEditEnabledCheckbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isBatchEditEnabled) ? _vm._i(_vm.isBatchEditEnabled, null) > -1 : _vm.isBatchEditEnabled
    },
    on: {
      "change": function ($event) {
        var $$a = _vm.isBatchEditEnabled,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isBatchEditEnabled = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.isBatchEditEnabled = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.isBatchEditEnabled = $$c;
        }
      }
    }
  }), _c('label', {
    staticClass: "form-check-label",
    attrs: {
      "for": "isBatchEditEnabledCheckbox"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('template.buttons.batch-edit.label')) + " ")])]) : _vm._e()]), _vm.hasPermission('locations.create') ? _c('div', {
    staticClass: "col-6 text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "tag": "a",
      "to": {
        name: 'locationCreate'
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('template.buttons.create-location.label')) + " ")])], 1) : _vm._e(), _c('div', {
    staticClass: "col-12 mt-2 mb-2"
  }, [_c('div', {
    staticClass: "card mb-2"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('h3', {
    staticClass: "card-title"
  }, [_vm._v(" " + _vm._s(_vm.$t('template.filters.title')) + " ")]), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }, [_c('div', {
    staticClass: "form-row form-group-sm"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('label', {
    attrs: {
      "for": "filterStoreIdentifier"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.search.filters.labels.store-identifier')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.filters.identifier,
      expression: "filters.identifier",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "filterName"
    },
    domProps: {
      "value": _vm.filters.identifier
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.filters, "identifier", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "col"
  }, [_c('label', {
    attrs: {
      "for": "filterName"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.search.filters.labels.store-name')) + " ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.filters.name,
      expression: "filters.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "filterName"
    },
    domProps: {
      "value": _vm.filters.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.filters, "name", $event.target.value.trim());
      },
      "blur": function ($event) {
        return _vm.$forceUpdate();
      }
    }
  })]), _c('div', {
    staticClass: "col"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.search.filters.labels.store-type')) + " ")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.type,
      expression: "filters.type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filterType"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filters, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option'), _vm._l(_vm.uniqueTypes, function (type) {
    return _c('option', {
      domProps: {
        "value": type
      }
    }, [_vm._v(_vm._s(type))]);
  })], 2)]), _c('div', {
    staticClass: "col"
  }, [_c('label', [_vm._v(" " + _vm._s(_vm.$t('omt.gui.location-management.search.filters.labels.store-active')) + " ")]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.filters.active,
      expression: "filters.active"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "filterActive"
    },
    on: {
      "change": function ($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.$set(_vm.filters, "active", $event.target.multiple ? $$selectedVal : $$selectedVal[0]);
      }
    }
  }, [_c('option'), _c('option', {
    domProps: {
      "value": '1'
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.label.yes')) + " ")]), _c('option', {
    domProps: {
      "value": '0'
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('omt.gui.general.label.no')) + " ")])])])])])])]), _vm.isBatchEditEnabled ? _c('div', {
    staticClass: "col-12 px-0 my-4"
  }, [_c('button', {
    staticClass: "btn btn-info",
    attrs: {
      "type": "button",
      "disabled": !_vm.locationsSelectedForBatchEdit.length
    },
    on: {
      "click": function ($event) {
        _vm.isModalOpen = _vm.isBatchAddOpeningTimesOpen = !_vm.isModalOpen;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('template.buttons.add-custom-opening-times.label')) + " ")])]) : _vm._e(), _c('b-card', [_c('b-card-title', {
    staticClass: "text-uppercase"
  }, [_vm._v(" " + _vm._s(_vm.$t('template.results.title')) + " ")]), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-hover"
  }, [_c('colgroup', [_vm.isBatchEditEnabled ? _c('col', {
    staticStyle: {
      "width": "40px"
    }
  }) : _vm._e(), _c('col', {
    staticStyle: {
      "width": "10%"
    }
  }), _c('col', {
    staticStyle: {
      "width": "auto"
    }
  }), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  }), _c('col', {
    staticStyle: {
      "width": "120px"
    }
  }), _c('col', {
    staticStyle: {
      "width": "140px"
    }
  })]), _c('tr', [_vm.isBatchEditEnabled ? _c('th', {
    staticClass: "pr-0 py-1 mr-0"
  }, [_c('button', {
    staticClass: "btn btn-sm btn-link p-0",
    staticStyle: {
      "line-height": "180%"
    },
    attrs: {
      "title": "Selectie omkeren"
    },
    on: {
      "click": function ($event) {
        return _vm.invertSelection();
      }
    }
  }, [_c('span', {
    staticClass: "lead"
  }, [_vm._v("≠")])])]) : _vm._e(), _c('th', [_vm._v(" " + _vm._s(_vm.$t('template.results.table.header.id')) + " ")]), _c('th', [_vm._v(" " + _vm._s(_vm.$t('template.results.table.header.name')) + " ")]), _c('th', [_vm._v(" " + _vm._s(_vm.$t('template.results.table.header.type')) + " ")]), _c('th', [_vm._v(" " + _vm._s(_vm.$t('template.results.table.header.active')) + " ")]), _c('th', {
    staticStyle: {
      "width": "130px"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('template.results.table.header.actions')) + " ")])]), _c('tbody', _vm._l(_vm.locationsFiltered, function (location) {
    return _c('tr', [_vm.isBatchEditEnabled ? _c('td', {
      staticClass: "pr-0 mr-0"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: location.batch_edit,
        expression: "location.batch_edit"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(location.batch_edit) ? _vm._i(location.batch_edit, null) > -1 : location.batch_edit
      },
      on: {
        "change": function ($event) {
          var $$a = location.batch_edit,
            $$el = $event.target,
            $$c = $$el.checked ? true : false;
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && _vm.$set(location, "batch_edit", $$a.concat([$$v]));
            } else {
              $$i > -1 && _vm.$set(location, "batch_edit", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
            }
          } else {
            _vm.$set(location, "batch_edit", $$c);
          }
        }
      }
    })]) : _vm._e(), _c('td', [_vm._v(_vm._s(location.identifier))]), _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'locationEditContactInfo',
          params: {
            locationTypeIdentifier: location.location_type.identifier,
            locationIdentifier: location.identifier
          }
        },
        "tag": "td"
      }
    }, [_vm._v(" " + _vm._s(location.display_name) + " ")]), _c('td', [_vm._v(" " + _vm._s(location.location_type.display_name) + " ")]), _c('td', [location.active === '1' ? _c('span', [_vm._v(" " + _vm._s(_vm.$t('template.results.table.body.active.yes')) + " ")]) : _c('span', [_vm._v(" " + _vm._s(_vm.$t('template.results.table.body.active.no')) + " ")])]), _c('td', {
      staticClass: "p-1"
    }, [_vm.hasLocationPermission(location.location_type.identifier, location.identifier, 'locations.contactinfo.view') ? _c('router-link', {
      staticClass: "btn btn-sm btn-link text-body",
      attrs: {
        "to": {
          name: 'locationEditContactInfo',
          params: {
            locationTypeIdentifier: location.location_type.identifier,
            locationIdentifier: location.identifier
          }
        },
        "tag": "a",
        "title": _vm.$t('template.results.table.body.edit-contact-info')
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "edit"
      }
    })], 1) : _vm._e(), _vm.hasLocationPermission(location.location_type.identifier, location.identifier, 'locations.servicetimes.edit') ? _c('router-link', {
      staticClass: "btn btn-sm btn-link text-body",
      attrs: {
        "to": {
          name: 'locationEditServiceTimes',
          params: {
            locationTypeIdentifier: location.location_type.identifier,
            locationIdentifier: location.identifier
          }
        },
        "tag": "a",
        "title": _vm.$t('template.results.table.body.edit-service-times')
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "clock"
      }
    })], 1) : _vm._e(), _vm.hasLocationPermission(location.location_type.identifier, location.identifier, 'locations.services.view') ? _c('router-link', {
      staticClass: "btn btn-sm btn-link text-body",
      attrs: {
        "to": {
          name: 'EditLocationServices',
          params: {
            locationTypeIdentifier: location.location_type.identifier,
            locationIdentifier: location.identifier
          }
        },
        "tag": "a",
        "title": _vm.$t('template.results.table.body.edit-service-settings')
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "cube"
      }
    })], 1) : _vm._e(), _vm.hasLocationPermission(location.location_type.identifier, location.identifier, 'locations.properties.edit') ? _c('router-link', {
      staticClass: "btn btn-sm btn-link text-body",
      attrs: {
        "to": {
          name: 'EditLocationProperties',
          params: {
            locationTypeIdentifier: location.location_type.identifier,
            locationIdentifier: location.identifier
          }
        },
        "tag": "a",
        "title": _vm.$t('template.results.table.body.edit-properties')
      }
    }, [_c('font-awesome-icon', {
      attrs: {
        "icon": "cogs"
      }
    })], 1) : _vm._e()], 1)], 1);
  }), 0)])])], 1), _vm.isLoading ? _c('div', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  })], 1) : _vm._e()], 1)]), _c('b-modal', {
    attrs: {
      "id": "vue-modal",
      "title": "Batch Edit",
      "hide-header": true,
      "hide-footer": true,
      "size": "xl"
    },
    model: {
      value: _vm.isModalOpen,
      callback: function ($$v) {
        _vm.isModalOpen = $$v;
      },
      expression: "isModalOpen"
    }
  }, [_vm.isBatchAddOpeningTimesOpen ? _c('batch-add-opening-times', {
    attrs: {
      "selected-results": _vm.locationsSelectedForBatchEdit,
      "show-header": true
    },
    on: {
      "close": function ($event) {
        _vm.isModalOpen = false;
      }
    }
  }) : _vm._e()], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }